import { upperCase } from 'lodash-es';
import { forwardRef } from 'react';

import { useMergedRef } from '@/hook';

import { useVBaseSelectContext } from '../VBaseSelect';
import { VFlex } from '../VFlex';
import { KeyboardArrowDown, KeyboardArrowUp, Language } from '../asset';
import { style } from './style';
import type { VInnerLanguageSwitchProps } from './type';

const VInnerLanguageSwitch = forwardRef(
  ({ selectedLanguage, languageList }: VInnerLanguageSwitchProps, ref) => {
    const { itemListVisible, $displayValue } = useVBaseSelectContext();
    const Icon = itemListVisible ? KeyboardArrowUp : KeyboardArrowDown;
    const refs = useMergedRef($displayValue, ref);
    const selectedLanguageLabel = upperCase(
      languageList.find(l => l.value === selectedLanguage)?.value,
    );

    return (
      <VFlex
        ref={refs}
        gap={0.25}
        className={style.languageSwitch(itemListVisible)}
        role="button"
        items="center"
      >
        <VFlex gap={0.25} items="center">
          <Language className={style.icon} />
          <div>{selectedLanguageLabel ?? ''}</div>
        </VFlex>

        <Icon className={style.icon} />
      </VFlex>
    );
  },
);

export default VInnerLanguageSwitch;
